import { Component } from 'react'
import PropTypes from 'prop-types'
import { map, noop, includes } from 'lodash'
import HorizontalSpinner from '@components/HorizontalSpinner.tsx'
import PhotoLibraryItem from './photo_library_item'

export default class PhotoLibraryPage extends Component {
  static propTypes = {
    isFetching: PropTypes.bool.isRequired,
    photos: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    photoDeletions: PropTypes.array.isRequired,
  }

  static defaultProps = {
    onSelect: noop,
    onDelete: noop,
    photoDeletions: [],
  }

  handleSelect = photoId => {
    const { onSelect } = this.props
    onSelect(photoId)
  }

  handleDelete = photoId => {
    const { onDelete } = this.props
    onDelete(photoId)
  }

  getContent() {
    const { photos, isFetching, photoDeletions } = this.props
    if (isFetching) {
      return (
        <div className="p">
          <HorizontalSpinner size="large" />
        </div>
      )
    } else if (photos.length === 0) {
      return <p>No photos.</p>
    } else {
      const sortedPhotos = photos.sort((a, b) => {
        const aCreatedAt = a.created_at || a.attributes?.created_at
        const bCreatedAt = b.created_at || b.attributes?.created_at
        return new Date(bCreatedAt) - new Date(aCreatedAt)
      })

      let content = map(sortedPhotos, photo => {
        const photoId = photo.id
        const isDeleting = includes(photoDeletions, photoId)
        return (
          <PhotoLibraryItem
            key={`photo_library_item_${photoId}`}
            photo={photo}
            onSelect={this.handleSelect}
            onDelete={this.handleDelete}
            isDeleting={isDeleting}
          />
        )
      })
      return <div className="photo-library__photos">{content}</div>
    }
  }

  render() {
    return <div>{this.getContent()}</div>
  }
}
